import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";
import { ref } from "vue";

interface Emits {
  (e: "add-attachment", files: FileList): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputAttachment',
  emits: ["add-attachment"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const fileInput = ref<HTMLInputElement>();

const focusFileInput = () => {
  if (!fileInput.value) {
    return;
  }
  fileInput.value.value = "";
  fileInput.value.click();
};
const addAttachment = (e: Event) => {
  const target = e.target as HTMLInputElement;
  const files = target.files;
  if (!files) {
    return;
  }
  emit("add-attachment", files);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", {
      class: "input-attachment",
      onClick: focusFileInput
    }, [
      _createVNode(Icon, {
        icon: _unref(IconType).CLIP
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      class: "fileInput",
      type: "file",
      multiple: "",
      onChange: addAttachment
    }, null, 544)
  ]))
}
}

})